import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import SocialLink from '../SocialLink';

export default class ArticleSocialLinks extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <div className={css(styles.social_links_container)}>
          <div className={css(styles.text)}>Share via</div>
          <SocialLink type='facebook' url={`http://facebook.com/sharer.php?u=${this.props.url}`} />
          <SocialLink type='twitter' url={`http://twitter.com/home?status=${this.props.title} - ${this.props.url}`} />
          <SocialLink type='email' url={`mailto:?subject=${this.props.title}&body=${this.props.url}`} />
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    margin: '50px auto 0px',
  },
  social_links_container: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    display: 'inline-block',
    fontFamily: Theme.fontFamily,
    fontWeight: 900,
    color: Theme.dark_grey,
    letterSpacing: 2,
    fontSize: 10,
    textTransform: 'uppercase',
  },
})



// WEBPACK FOOTER //
// ./src/components/ArticleSocialLinks/index.js